// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const CalendarEditReminders = props => (
    <CalendarEdit {...props} calendarType="reminders" />
);
export default CalendarEditReminders;